import { Address, PublicClient } from 'viem';

import { getStakingPoolFactoryContract } from 'modules/api/contracts/getStakingPoolFactoryContract';
import { memoizePromise } from 'modules/api/methods/memoizePromise';

export async function _getPoolOwnershipAddress(
  client: PublicClient,
): Promise<Address> {
  const contract = await getStakingPoolFactoryContract(client);

  return await contract.read.ownershipNFT();
}

export const getPoolOwnershipAddress = memoizePromise(
  _getPoolOwnershipAddress,
  client => {
    return `${client.chain?.id || 'unknown'}`;
  },
);
